/**
 * @generated SignedSource<<a3025b0c81bfb7af64ed62af5290a974>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductSkuOfferDeliveryChannel = "DELIVERY" | "PICKUP_IN_POINT" | "TAKE_AWAY";
import { FragmentRefs } from "relay-runtime";
export type ProductSkuAvailabilityPickup_ProductSkuOfferConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly deliveryChannel: ProductSkuOfferDeliveryChannel;
      readonly netPrice: {
        readonly amount: number;
      };
      readonly deliveryAvailabilities: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name: string;
            readonly pickupDistance: number;
            readonly shippingEstimate: string;
            readonly netPrice: {
              readonly amount: number;
            };
          };
        }>;
      };
    };
  }>;
  readonly " $fragmentType": "ProductSkuAvailabilityPickup_ProductSkuOfferConnection";
};
export type ProductSkuAvailabilityPickup_ProductSkuOfferConnection$key = {
  readonly " $data"?: ProductSkuAvailabilityPickup_ProductSkuOfferConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailabilityPickup_ProductSkuOfferConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "netPrice",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuAvailabilityPickup_ProductSkuOfferConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuOfferEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuOffer",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveryChannel",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuOfferDeliveryAvailabilityConnection",
              "kind": "LinkedField",
              "name": "deliveryAvailabilities",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSkuOfferDeliveryAvailabilityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuOfferDeliveryAvailability",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "pickupDistance",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "shippingEstimate",
                          "storageKey": null
                        },
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuOfferConnection",
  "abstractKey": null
};
})();

(node as any).hash = "99fc136d9a66ceb27c7c44e5bb318d1a";

export default node;
